import { useEffect } from "react";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import { KBD } from "../utils/Keybindings";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import { useTabs } from "../hooks/useTabs";
import Button from "../ui/Button";

export default function TestComponent(props) {

    const { selected = {}, view = "", setView = () => { }, route = ROUTES.MISC.TEST_DETAILS } = props;


    const can_edit = (view === "details");


    const defaultTabs = [
        { label: "date_from", key: "date_from", value: "some value" },
        { label: "date_to", key: "date_to", value: "" },
        { label: "button", key: "button", value: "" },
    ]

    const {
        tabs, setTabs, index, setIndex, update, getVal, editProps, next, prev, refs
    } = useTabs(defaultTabs, "date_from");


    useEffect(() => {
        if (refs?.current[index]) refs.current[index].focus();
    }, [index]);

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: () => setView("list") },
            { key: KBD.SHIFT_TAB, action: () => { prev() } },
            { key: KBD.TAB, action: () => { next() } },
            { key: KBD.ENTER, action: () => { prev() } },
            { key: KBD.ARROW_DOWN, action: () => { next() } },
            { key: KBD.ARROW_UP, action: () => { prev() } },
            // { key: KBD.ENTER, action: () => { if (index === "date_to_time") { onSave(false, tabs); goto("sales_types") } else { next(); } } },
            // { key: KBD.ARROW_DOWN, action: () => { if (index === "date_to_time") { onSave(false, tabs); goto("sales_types") } else { next(); } } },
            // { key: KBD.ARROW_UP, action: () => { if (index === "date_from") { goto("scope_type") } else { prev(); } } },
            // { key: KBD.PAGE_DOWN, action: () => onSave(true, tabs) },
        ]
        const cleanup = listen(route, actions, () => { }, [KBD.ESCAPE, KBD.SHIFT_TAB, KBD.TAB, KBD.ENTER, KBD.ARROW_DOWN]);
        return cleanup;
    }, [index, tabs])

    return (
        <div style={{ "padding": "20px 10px" }}>
            <Space>
                <Label>Field:</Label><Input width={100} {...editProps("date_from")} edit={can_edit} />
                <Label>Field:</Label><Input width={100} {...editProps("date_to")} edit={can_edit} />
                <Button onClick={() => update("date_from", "yo!")} type="primary" {...editProps("button")}>Click</Button>

            </Space>

            {/* <pre>{JSON.stringify(tabs, null, 2)}</pre> */}

        </div>
    )

}